import { useQueryClient as u, useMutation as r } from "@tanstack/vue-query";
import { runBatchOrThrow as q } from "../../bulk/run-batch-or-throw.js";
import { adGroupKeys as m } from "../ad-group/queries.js";
import { campaignKeys as p } from "../campaign/queries.js";
import { creativeKeys as v, creativeGroupKeys as o, landingKeys as y } from "./queries.js";
import "vue";
const d = async (t, s) => {
  await t.invalidateQueries({ queryKey: o.byCampaign(s) }), await t.invalidateQueries({ queryKey: m.byCampaign(s) }), await t.invalidateQueries({ queryKey: p.byCampaign(s) });
}, Q = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => {
      const c = {
        campaignId: e.campaignId,
        ...e.body
      };
      return t.creativeGroup.create(c);
    },
    onSuccess: async (...e) => {
      const [, c] = e;
      await n.invalidateQueries({ queryKey: o.byCampaign(c.campaignId) }), await n.invalidateQueries({ queryKey: p.byCampaign(c.campaignId) }), a && a(...e);
    }
  });
}, O = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => {
      await t.creativeGroup.update({
        creativeGroupId: e.creativeGroupId,
        ...e.body
      });
    },
    onSuccess: async (...e) => {
      const [, c] = e;
      await d(n, c.campaignId), a && a(...e);
    }
  });
}, b = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => {
      await t.creativeGroup.rename({
        creativeGroupId: e.creativeGroupId,
        ...e.body
      });
    },
    onSuccess: async (...e) => {
      const [, c] = e;
      await n.invalidateQueries({ queryKey: o.byCampaign(c.campaignId) }), await n.invalidateQueries({ queryKey: p.byCampaign(c.campaignId) }), a && a(...e);
    }
  });
}, F = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.creativeGroup.remove({ creativeGroupId: e.creativeGroupId }),
    onSuccess: async (...e) => {
      const [, c] = e;
      n.removeQueries({
        queryKey: o.detail(c.campaignId, c.creativeGroupId)
      }), await n.invalidateQueries({ queryKey: o.byCampaign(c.campaignId) }), await n.invalidateQueries({ queryKey: p.byCampaign(c.campaignId) }), a && a(...e);
    }
  });
}, D = (t, s) => {
  const n = u();
  return r({
    ...s,
    mutationFn: async (a) => {
      await t.creativeGroup.update({
        creativeGroupId: a.creativeGroupId,
        ...a.body
      });
    },
    onMutate: async (a) => {
      await n.cancelQueries({
        queryKey: o.detail(a.campaignId, a.creativeGroupId)
      });
      const e = n.getQueryData(
        o.detail(a.campaignId, a.creativeGroupId)
      );
      return e && n.setQueryData(
        o.detail(a.campaignId, a.creativeGroupId),
        {
          ...e,
          ...a.body,
          autoRotateIsEnabled: a.body.autoRotateIsEnabled !== void 0 ? a.body.autoRotateIsEnabled : e.autoRotateIsEnabled
        }
      ), e !== void 0 ? { previousData: e } : {};
    },
    onError: (a, e, c) => {
      c?.previousData && n.setQueryData(
        o.detail(e.campaignId, e.creativeGroupId),
        c.previousData
      );
    },
    onSettled: async (a, e, c) => {
      await d(n, c.campaignId);
    }
  });
}, L = (t, s) => {
  const n = u(), { skipInvalidation: a = !1, onSuccess: e, ...c } = s ?? {};
  return r({
    ...c,
    mutationFn: async (i) => t.asset.create(i),
    onSuccess: async (...i) => {
      if (!a) {
        const [, l] = i;
        await d(n, l.campaignId);
      }
      e && e(...i);
    }
  });
}, R = (t, s) => {
  const n = u(), { skipInvalidation: a = !1, onSuccess: e, ...c } = s ?? {};
  return r({
    ...c,
    mutationFn: async (i) => {
      const { creativeGroupId: l, campaignId: w, ...S } = i;
      await t.asset.update({
        params: { assetId: S.id },
        query: { force: i.force ?? !1 },
        body: S
      });
    },
    onSuccess: async (...i) => {
      if (!a) {
        const [, l] = i;
        await d(n, l.campaignId);
      }
      e && e(...i);
    }
  });
}, U = (t, s) => {
  const n = u(), { onSuccess: a, ...e } = s ?? {};
  return r({
    ...e,
    mutationFn: async (c) => {
      await q(
        c.assets,
        (i) => t.asset.update({
          params: { assetId: i.id },
          query: { force: c.force ?? !1 },
          body: i
        })
      );
    },
    onSuccess: async (...c) => {
      const [, i] = c;
      await d(n, i.campaignId), a && a(...c);
    }
  });
}, A = (t, s) => {
  const n = u(), { skipInvalidation: a = !1, onSuccess: e, ...c } = s ?? {};
  return r({
    ...c,
    mutationFn: async (i) => t.asset.remove({ params: { assetId: i.assetId }, query: { force: i.force ?? !1 } }),
    onSuccess: async (...i) => {
      if (!a) {
        const [, l] = i;
        await d(n, l.campaignId);
      }
      e && e(...i);
    }
  });
}, E = (t, s) => {
  const n = u(), { onSuccess: a, ...e } = s ?? {};
  return r({
    ...e,
    mutationFn: async (c) => {
      await q(
        c.assetIds,
        (i) => t.asset.remove({
          params: { assetId: i },
          query: { force: c.force ?? !1 }
        })
      );
    },
    onSuccess: async (...c) => {
      const [, i] = c;
      await d(n, i.campaignId), a && a(...c);
    }
  });
}, _ = (t, s) => {
  const n = u();
  return r({
    ...s,
    mutationFn: async (a) => {
      await t.review.landings.review(a);
    },
    onSuccess: async () => {
      await n.invalidateQueries({ queryKey: y.all }), await n.invalidateQueries({ queryKey: o.all }), await n.invalidateQueries({ queryKey: m.all });
    }
  });
}, k = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landings.create(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, h = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landings.update(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, M = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.creatives.create(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: v.all }), a && a(...e);
    }
  });
}, T = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.creatives.createCustomContent(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: v.all }), a && a(...e);
    }
  });
}, B = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.creatives.update(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: v.all }), await n.invalidateQueries({ queryKey: o.all }), await n.invalidateQueries({ queryKey: m.all }), a && a(...e);
    }
  });
}, j = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.creatives.remove(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: v.all }), a && a(...e);
    }
  });
}, x = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landings.remove(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, z = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landingGroups.create(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, H = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landingGroups.update(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, J = (t, s) => {
  const n = u(), a = s?.onSuccess;
  return r({
    ...s,
    mutationFn: async (e) => t.landingGroups.remove(e),
    onSuccess: async (...e) => {
      await n.invalidateQueries({ queryKey: y.all }), a && a(...e);
    }
  });
}, N = (t, s) => {
  const n = u();
  return r({
    ...s,
    mutationFn: async (a) => {
      await t.review.creatives.review(a);
    },
    onSuccess: async () => {
      await n.invalidateQueries({ queryKey: v.all }), await n.invalidateQueries({ queryKey: o.all }), await n.invalidateQueries({ queryKey: m.all });
    }
  });
};
export {
  L as useCreateAsset,
  M as useCreateCreative,
  Q as useCreateCreativeGroup,
  T as useCreateCustomContentCreative,
  k as useCreateLanding,
  z as useCreateLandingGroup,
  A as useDeleteAsset,
  E as useDeleteAssets,
  j as useDeleteCreative,
  F as useDeleteCreativeGroup,
  x as useDeleteLanding,
  J as useDeleteLandingGroup,
  b as useRenameCreativeGroup,
  N as useReviewCreative,
  _ as useReviewLanding,
  R as useUpdateAsset,
  U as useUpdateAssets,
  B as useUpdateCreative,
  O as useUpdateCreativeGroup,
  D as useUpdateCreativeGroupOptimistic,
  h as useUpdateLanding,
  H as useUpdateLandingGroup
};
//# sourceMappingURL=mutations.js.map
